import type { SummaryItemDescriptor } from '../extras';

const PURCHASE_SUMMARY_ITEMS: Record<string, Omit<SummaryItemDescriptor, 'id'>> = {
  lottoPlus: { translationKey: 'tippengine.extras.options.games.lottoPlus.title' },
  powerPlay: { translationKey: 'tippengine.extras.options.games.powerPlay.title' },
};

function getOptionSummaryItems(options: string[]): SummaryItemDescriptor[] {
  return options.flatMap(option => {
    const summaryItem = PURCHASE_SUMMARY_ITEMS[option];
    if (!summaryItem) return [];

    return [{ id: `option-${option}`, ...summaryItem }];
  });
}

export { getOptionSummaryItems };
